import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "addButton"]
  static values = { 
    index: Number,
    idTypes: Array
  }

  connect() {
    this.indexValue = this.data.get("index") || this.containerTarget.querySelectorAll('.identification-field').length
    this.updatePlaceholders()
    this.updateAddButtonVisibility()
  }

  addNewIdentification() {
    const newField = document.createElement('div')
    newField.className = 'identification-field border border-gray-200 rounded-lg p-4'
    newField.setAttribute('data-index', this.indexValue)

    const idTypesOptions = this.idTypesValue.map(([label, value]) =>
      `<option value="${value}">${label}</option>`
    ).join('')

    newField.innerHTML = `
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">
            Identification Type
          </label>
          <select name="user[user_identifications_attributes][${this.indexValue}][id_type]"
                  class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-xs focus:outline-hidden focus:ring-primary focus:border-primary sm:text-sm"
                  data-action="change->user-identification#updatePlaceholder">
            <option value="">Select ID type</option>
            ${idTypesOptions}
          </select>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Identification Number</label>
          <input type="text"
                 name="user[user_identifications_attributes][${this.indexValue}][id_number]"
                 placeholder="Enter identification number"
                 class="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-xs focus:outline-hidden focus:ring-primary focus:border-primary sm:text-sm">
        </div>
      </div>
      <div class="mt-4 flex items-center justify-between">
        <div class="flex items-center">
          <input type="hidden" name="user[user_identifications_attributes][${this.indexValue}][primary]" value="0">
          <input type="checkbox"
                 name="user[user_identifications_attributes][${this.indexValue}][primary]"
                 value="1"
                 class="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded-sm">
          <label class="ml-2 block text-sm text-gray-900">Primary ID</label>
        </div>
        <button type="button"
                data-action="click->user-identification#removeNewIdentification"
                class="text-red-600 hover:text-red-800 text-sm">
          Remove
        </button>
      </div>
    `

    this.containerTarget.insertBefore(newField, this.addButtonTarget)
    this.indexValue++
    this.updateAddButtonVisibility()
  }

  removeNewIdentification(event) {
    const field = event.target.closest('.identification-field')
    const destroyInput = field.querySelector('input[name*="[_destroy]"]')

    if (destroyInput) {
      destroyInput.value = '1'
      field.style.display = 'none'
    } else {
      field.remove()
    }
    this.updateAddButtonVisibility()
  }

  updatePlaceholder(event) {
    const select = event.target
    const idType = select.value
    const idNumberField = select.closest('.grid').querySelector('input[name*="[id_number]"]')
    
    if (idNumberField) {
      const placeholders = {
        'national_id': 'e.g., CM12345678901234',
        'passport': 'e.g., A1234567',
        'refugee_id': 'e.g., RF123456',
        'business_license': 'e.g., BL123456789',
        'tax_id': 'e.g., 1234567890',
        'employee_id': 'e.g., EMP12345',
        'badge_number': 'e.g., BADGE123'
      }
      
      idNumberField.placeholder = placeholders[idType] || 'Enter identification number'
    }
  }

  updatePlaceholders() {
    // Initialize placeholders for existing fields
    const existingSelects = this.containerTarget.querySelectorAll('select[name*="[id_type]"]')
    existingSelects.forEach(select => {
      if (select.value) {
        this.updatePlaceholder({ target: select })
      }
    })
  }

  updateAddButtonVisibility() {
    // Count visible identification fields (not marked for destruction and not hidden)
    const visibleFields = Array.from(this.containerTarget.querySelectorAll('.identification-field'))
      .filter(field => field.style.display !== 'none')

    // Show "Add Another ID" button only if at least one field exists
    if (visibleFields.length > 0) {
      this.addButtonTarget.classList.remove('hidden')
    } else {
      this.addButtonTarget.classList.add('hidden')
    }
  }
}